import { MAX_INTEGER, MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";
import { useMemo } from "react";

export const useGetMonthlyTargetSchema = () => {
  const monthlyTargetSchema = useMemo(() => {
    return validator.object().shape({
      targetJobs: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("月間新規求人数の目標値")
        .notRequired(),
      targetCases: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("月間新規案件数の目標値")
        .notRequired(),
      targetTalents: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("月間新規登録人材数の目標値")
        .notRequired(),
      targetOpenJobs: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("募集中求人数の目標値")
        .notRequired(),
      targetMatchingBeforeProposals: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("月間マッチング推薦前数の目標値")
        .notRequired(),
      targetMatchingBeforeProposalRate: validator
        .number()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .min(0)
        .max(100)
        .label("月間マッチング推薦前転換率の目標値")
        .notRequired(),
      targetMatchingRecommendations: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("月間マッチング推薦数の目標値")
        .notRequired(),
      targetMatchingRecommendationRate: validator
        .number()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .min(0)
        .max(100)
        .label("月間マッチング推薦転換率の目標値")
        .notRequired(),
      targetMatchingInterviews: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("月間マッチング面接数の目標値")
        .notRequired(),
      targetMatchingInterviewRate: validator
        .number()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .min(0)
        .max(100)
        .label("月間マッチング面接転換率の目標値")
        .notRequired(),
      targetMatchingOffers: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("月間マッチング内定数の目標値")
        .notRequired(),
      targetMatchingOfferRate: validator
        .number()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .min(0)
        .max(100)
        .label("月間マッチング内定転換率の目標値")
        .notRequired(),
      targetMatchingAcceptances: validator
        .number()
        .commas()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .integer()
        .min(0)
        .max(MAX_INTEGER)
        .label("月間マッチング内定受諾数の目標値")
        .notRequired(),
      targetMatchingAcceptanceRate: validator
        .number()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .nullable()
        .min(0)
        .max(100)
        .label("月間マッチング内定受諾転換率の目標値")
        .notRequired(),
      memo: validator.string().trim().max(MAX_TEXT_INPUT_VALIDATION).emptyToNull().nullable().label("目標に関するメモ").notRequired(),
    });
  }, []);

  return { monthlyTargetSchema };
};
